// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fourStories-m__wrapper__3xtFw","stories":"fourStories-m__stories__3i8c6","first-story":"fourStories-m__first-story__1EFBC"};